import React from 'react'
import FirstView from '../../../../components/Business/Hotelslabo/FirstView'
import Summary from '../../../../components/Business/Hotelslabo/Summary'
import Point from '../../../../components/Business/Hotelslabo/Point'
import Flow from '../../../../components/Business/Hotelslabo/Flow'
import Introduction from '../../../../components/Business/Hotelslabo/Introduction'
import Question from '../../../../components/Business/Hotelslabo/Question'
import ContactInduction from '../../../../components/Business/Hotelslabo/ContactInduction'
import Footer from '../../../../components/Business/Hotelslabo/Footer'

export default function HotelslaboContact() {
    return (
        <>
            <FirstView />
            <Summary />
            <Point />
            <Flow />
            <Introduction />
            <Question />
            <ContactInduction />
            <Footer />
        </>
    )
}
